<template>
  <form @submit.prevent="login">
    <div>
      <section class="section">
        <div class="card">
          <div class="card-content">
            <div class="field is-required">
              <label class="label">Username</label>
              <p class="control has-icons-left has-icons-right">
                <input class="input" type="text" v-model="username" placeholder="Username" required />
                <span class="icon is-small is-left">
                  <i class="fa fa-user"></i>
                </span>
              </p>
            </div>
            <div class="field is-required">
              <label class="label">Password</label>
              <p class="control has-icons-left">
                <input
                  class="input"
                  type="password"
                  v-model="password"
                  placeholder="Password"
                  required
                />
                <span class="icon is-small is-left">
                  <i class="fa fa-lock"></i>
                </span>
              </p>
            </div>
            <div class="field">
              <p class="control">
                <button class="button is-primary">Login</button>
              </p>
              <p class="help is-danger" v-if="error">{{error}}</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  </form>
</template>

<script>
export default {
  name: "LoginForm",
  props: {
    msg: String,
    error: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      username: "",
      password: ""
    };
  },
  methods: {
    login() {
      this.$emit("submit", {
        username: this.username,
        password: this.password
      });
    }
  }
};
</script>